module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-04a.0f0e5ec6.jpg";